<template>
    <div @click="toggleSelect">{{ this.title }}</div>
    <!-- <div v-bind:class="[{ selected: this.selected }, this.function]" @click="toggleSelect">{{ this.title }}</div> -->
</template>
<script>
export default {
    data() {
        // return {
        //     selected: false,
        // }
    },
    props: {
        title: String,
        // function: String,
    },
    methods: {
        // toggleSelect() {
        //     this.selected = !this.selected;
        // }
    }
}
</script>
<style scoped>
/* Fitler Styles */
.filter {
    /* Colors */
    background-color: rgb(205, 92, 92);
    border: solid 3px rgba(205, 92, 92, 0.7);
    /* spacing */
    padding: 2px 10px;
    border-radius: 15px;
}

.filter.selected {
    border: solid 3px rgba(205, 160, 92, 0.7);
    background-color: rgb(205, 160, 92);
}

.filter.selected:hover {
    background-color: rgba(205, 160, 92, 0.4);
    color: rgb(255, 255, 255);
}

.filter:hover {
    background-color: rgba(205, 92, 92, 0.4);
    color: rgb(255, 255, 255);
}

/* END Fitler Styles */

/* Tag Styles */
.tag {
    /* Fonts */
    font-family: typeBld;
    border-radius: 5px;
    /* Color */
    color: rgb(34, 34, 34);
    background-color: rgb(205, 92, 92);
    border: solid 3px rgba(205, 92, 92, 0.5);
    /* Spacing */
    padding: 2px 10px;
    cursor: default;
}

.tag.selected {
    border: solid 3px rgb(205, 160, 92);
    background-color: rgb(205, 160, 92);
}

/* END Tag Styles */

/* Button Styles */
.button {
    /* Font */
    font-family: "typeBld";
    /* style */
    cursor: pointer;
    text-decoration: none;
    border-radius: 5px;
    /* spacing */
    padding: 2px 10px;
    /* Colors */
    background-color: rgba(205, 92, 92, 0.3);
    color: rgb(34, 34, 34);
    border: solid 3px rgb(34, 34, 34);
}

.button:hover {
    background-color: rgba(205, 92, 92, 0.7);
    color: rgb(255, 255, 255);
}

.button.selected {
    background-color: rgb(205, 92, 92);
    border: solid 3px rgb(205, 92, 92);
}

/* END Button Styles */
</style>